<script>
  import { createEventDispatcher } from "svelte";
  import Input from "../../pages/permissionless/input-design/Input.svelte";
  import NETWORKS from "../../constants/network";
  import { formattedChainID } from "../../utils";
  import {chainId, signerAddress} from "svelte-ethers-store";
  import {ethers} from "ethers";
  import {getERC20, getSigner} from "../../contracts/utils/utils";

  const dispatch = createEventDispatcher();
  export let selectedAddress,
    reserveErc20,
    tokenDropdown,
    errors,
    dropDownArrow;
  let triggerEl, reserveFetching = false, filterAddresses = "", defaultAddresses, reserveTokenAddress;

  const fetchReserve = async (address) => {
    if (!ethers.utils.isAddress(address))
      return (errors = {
        ...errors,
        selectedAddress : "Reserve token should be valid",
      });

    reserveFetching = true;
    errors = {
      ...errors,
      selectedAddress: "",
    };

    let signer = await getSigner()
    tokenDropdown = false
    reserveErc20 = await getERC20(address, signer, $signerAddress);
    reserveFetching = false
  }

  const defaultReserveToken = () => {
   return NETWORKS[formattedChainID($chainId)]?.RESERVE_TOKEN_ADDRESSES[0].address ?? ""
  }

  fetchReserve(defaultReserveToken())

  $: if($chainId) {
    selectedAddress = defaultReserveToken();
    fetchReserve(selectedAddress)
    reserveErc20 = ""
  }

  const handleAddress = async (address) => {
    selectedAddress = address
    await fetchReserve(address)
  };
</script>

  <div class="drop-field">
    <Input
      bind:value={selectedAddress}
      on:change={(event) => {
        handleAddress(event.detail);
        errors = { ...errors, reserveToken: "" };
      }}
      id="reserve-token"
    >
      <label for="reserve-token" slot="label" class="form-label">
        Reserve Token
        <small>*</small>
      </label>
      <span
        slot="label_dec"
        class="form-label-dec relative flex flex-text-center"
      >
        <small class="mr-auto">
          Name: {reserveErc20 ? reserveErc20.erc20name : "-"}
        </small>
        <small>
          Symbol: {reserveErc20 ? reserveErc20.erc20symbol : "-"}
        </small>
        {#if reserveFetching}
          <img
            class="input-load"
            src="./images/btn-load.gif"
            alt="loader img"
          />
        {/if}
      </span>
    </Input>
  </div>
